import { gql } from "@apollo/client";
import {
  InvoiceArrivalItemNoNestingFragment,
  PaginatedListMetaNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";

const InvoiceFragment = `
${InvoiceArrivalItemNoNestingFragment}
  fragment CustomInvoiceArrivalFragment on InvoiceArrival {
    arrivalDate
    createdAt
    deletedAt
    dueDate
    freightCost
    id
    invoiceDate
    invoiceNumber
    orderNumber
    locationId
    status
    supplierId
    totalCost
    totalQuantity
    costPriceIncGST
    gstCredit
    formattedGSTCredit
    totalCostIncGST
    updatedAt
    location {
      name
    }
    supplier {
      name
    }
    items {
      ...InvoiceArrivalItemNoNesting
      product {
        name
        image {
          path
        }
        category {
          id
          markup {
            markupType
            markupStyle
            markupPercentage
          }
        }
        department {
          id
          markup {
            markupType
            markupStyle
            markupPercentage
          }
        }
      }
    }
  }
`;

export const QUERY_INVOICE_ARRIVAL = gql`
  ${InvoiceFragment}
  query invoiceArrival($id: ID!) {
    invoiceArrival(id: $id) {
      ...CustomInvoiceArrivalFragment
    }
  }
`;

export const QUERY_COUNT_INVOICE_ARRIVALS = gql`
  query invoiceArrivalsCount($options: InvoiceArrivalListOptions) {
    invoiceArrivalsCount(options: $options)
  }
`;

export const QUERY_INVOICE_ARRIVALS = gql`
  ${PaginatedListMetaNoNestingFragment}
  ${InvoiceFragment}
  query invoiceArrivals($options: InvoiceArrivalListOptions) {
    invoiceArrivals(options: $options) {
      items {
        ...CustomInvoiceArrivalFragment
      }
      meta {
        ...PaginatedListMetaNoNesting
      }
    }
  }
`;

export const MUTATION_CREATE_INVOICE_ARRIVAL = gql`
  ${InvoiceFragment}
  ${InvoiceArrivalItemNoNestingFragment}
  mutation createInvoiceArrival($input: CreateInvoiceArrivalInput!) {
    createInvoiceArrival(input: $input) {
      ...CustomInvoiceArrivalFragment
    }
  }
`;

export const MUTATION_UPDATE_INVOICE_ARRIVAL = gql`
  ${InvoiceFragment}
  ${InvoiceArrivalItemNoNestingFragment}
  mutation updateInvoiceArrival($input: UpdateInvoiceArrivalInput!) {
    updateInvoiceArrival(input: $input) {
      ...CustomInvoiceArrivalFragment
    }
  }
`;

export const MUTATION_DELETE_INVOICE_ARRIVAL = gql`
  mutation deleteInvoiceArrival($id: ID!) {
    deleteInvoiceArrival(id: $id) {
      reason
      result
    }
  }
`;

export const MUTATION_UPDATE_INVOICE_ARRIVAL_LINE_ITEMS = gql`
  ${InvoiceFragment}
  ${InvoiceArrivalItemNoNestingFragment}
  mutation updateInvoiceArrivalLineItems(
    $id: ID!
    $itemsToUpdate: [UpdateInvoiceArrivalLineItemInput!]
    $itemsToCreate: [CreateInvoiceArrivalLineItemInput!]
    $itemsToRemove: [ID!]
  ) {
    updateInvoiceArrivalLineItems(
      invoiceArrivalId: $id
      itemsToUpdate: $itemsToUpdate
      itemsToCreate: $itemsToCreate
      itemsToRemove: $itemsToRemove
    ) {
      ...CustomInvoiceArrivalFragment
    }
  }
`;

export const MUTATION_CANCEL_INVOICE_ARRIVAL = gql`
  ${InvoiceFragment}
  ${InvoiceArrivalItemNoNestingFragment}
  mutation cancelInvoiceArrival($id: ID!) {
    cancelInvoiceArrival(id: $id) {
      ...CustomInvoiceArrivalFragment
    }
  }
`;

export const MUTATION_COMPLETE_INVOICE_ARRIVAL = gql`
  ${InvoiceFragment}
  ${InvoiceArrivalItemNoNestingFragment}
  mutation completeInvoiceArrival($id: ID!) {
    completeInvoiceArrival(id: $id) {
      ...CustomInvoiceArrivalFragment
    }
  }
`;

export const SEND_INVOICE_ARRIVAL_INBOUND_RETAILER = gql`
  mutation sendInvoiceArrivalInboundRetailer($id: ID!) {
    sendInvoiceArrivalInboundRetailer(id: $id) {
      success
    }
  }
`;
